import React, { PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { DefaultRowCell } from "../../../../Layout/SortedList";
import { formatPlannedDate } from "../../../../../helpers/dateHelpers";
import { formatQuantityValue } from "../../../../../helpers/unitOfMeasurementHelpers";
import BillOfLadingLinkCell from "./BillOfLadingLinkCell";
import DisplayFullDataButton from "../../../../Layout/SortedList/DisplayFullDataButton";
import ShipmentStatusCell from "./ShipmentStatusCell";
import SortedListStatusCell from "./SortedListStatusCell";

export default class SubListRow extends PureComponent {
  static propTypes = {
    breadcrumbStack: PropTypes.array,
    customerId: PropTypes.string,
    customerPOId: PropTypes.string,
    isFullDataDisplayed: PropTypes.bool,
    isMobile: PropTypes.bool,
    item: PropTypes.object,
    onDisplayFullData: PropTypes.func,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    breadcrumbStack: [],
    customerId: "",
    customerPOId: "",
    isFullDataDisplayed: false,
    isMobile: false,
    item: {},
    onDisplayFullData: null,
    userMetadata: {}
  };

  state = {
    hasOverflowedChild: false
  };

  handleOverflowedChildState = () => {
    this.setState({
      hasOverflowedChild: true
    });
  };

  render() {
    const { customerId, customerPOId, breadcrumbStack, isFullDataDisplayed, isMobile, item = {}, onDisplayFullData, userMetadata } = this.props;
    const { hasOverflowedChild } = this.state;
    const isShipmentAvailable = item.quantityShipped && parseFloat(item.quantityShipped.value) !== 0;

    return (
      <div role="row" tabIndex="0" className={classNames("sorted-list__row", isFullDataDisplayed && "--full-data-displayed", "--sub")}>
        <DefaultRowCell
          className="--first --x4"
          header={isMobile ? `${i18n.t("loads.load")} # - ${i18n.t("loads.mill")}` : ""}
          onOverflowedChild={this.handleOverflowedChildState}
          value={`${item.loadId} - ${_.get(item, "mill.location.locationId", "")}`}
        />
        <SortedListStatusCell className="--x3" item={item} header={isMobile ? i18n.t("loads.deliveryStatus") : ""} />
        <DefaultRowCell
          className="--x3"
          header={isMobile ? i18n.t("loads.planning") : ""}
          onOverflowedChild={this.handleOverflowedChildState}
          value={formatPlannedDate(item.quantityPlanned, item, userMetadata)}
        />
        <DefaultRowCell
          className="--right --x2"
          header={isMobile ? i18n.t("loads.produced") : ""}
          onOverflowedChild={this.handleOverflowedChildState}
          value={formatQuantityValue(item.quantityProduced)}
        />
        <DefaultRowCell
          className="--right --x2"
          header={isMobile ? i18n.t("loads.shipped") : ""}
          onOverflowedChild={this.handleOverflowedChildState}
          value={formatQuantityValue(item.quantityShipped)}
        />
        <ShipmentStatusCell
          className="--x5"
          dateDisplayFormat={userMetadata.dateDisplayFormat}
          header={isMobile ? i18n.t("loads.shipmentStatus") : ""}
          loadShipmentStatus={item.loadShipmentStatus}
        />
        <BillOfLadingLinkCell
          breadcrumbStack={breadcrumbStack}
          className="--x1"
          customerId={customerId}
          customerPOId={customerPOId}
          isShipmentAvailable={isShipmentAvailable}
          loadId={item.id}
        />
        {isMobile && hasOverflowedChild && <DisplayFullDataButton isFullDataDisplayed={isFullDataDisplayed} onDisplayFullData={onDisplayFullData} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/List/Loads/SubListRow.js